module.exports = __webpack_public_path__ + "img/defalut-img.2226a3f6.png";